import React from 'react';

import { SpecCourseResults } from '../../spec-course.results/results';

interface Props {
    awardsRef: React.RefObject<HTMLDivElement>;
    resultsRef: React.RefObject<HTMLDivElement>;
}

export const SpecCourseLessonViewResultsTabContent = (props: Props) => {
    const { awardsRef, resultsRef } = props;

    return (
        <>
            <SpecCourseResults awardsRef={awardsRef} resultsRef={resultsRef} />
        </>
    );
};
